<form class="esn-feedback-form" novalidate [attr.aria-labelledby]="heading() ? headingId : null" (submit)="handleSubmit($event)">
  @if (heading() || description()) {
    <div class="esn-feedback-form__heading">
      @if (heading()) {
        <h2 class="esn-feedback-form__title" [id]="headingId">{{ heading() }}</h2>
      }
      @if (description()) {
        <p class="esn-feedback-form__description">{{ description() }}</p>
      }
    </div>
  }

  @if (kinds().length) {
    <div class="esn-feedback-form__kind">
      @if (kindLabel()) {
        <span class="esn-feedback-form__label" aria-hidden="true">{{ kindLabel() }}</span>
      }
      <esn-segmented
        class="esn-feedback-form__segmented"
        [options]="kinds()"
        [ariaLabel]="kindLabel() || null"
        [disabled]="disabled()"
        [(value)]="kind"
      />
    </div>
  }

  <esn-text-field
    name="subject"
    [label]="subjectLabel()"
    [placeholder]="subjectPlaceholder()"
    [disabled]="disabled()"
    [required]="true"
    [(value)]="subject"
  />

  <esn-text-field
    class="esn-feedback-form__details"
    name="details"
    kind="notes"
    [label]="detailsLabel()"
    [placeholder]="detailsPlaceholder()"
    [hint]="detailsHint()"
    [disabled]="disabled()"
    [required]="true"
    [(value)]="details"
  />

  @if (replyTo()) {
    <div class="esn-feedback-form__reply">
      @if (replyToLabel()) {
        <span class="esn-feedback-form__label">{{ replyToLabel() }}</span>
      }
      <output class="esn-feedback-form__readonly">{{ replyTo() }}</output>
    </div>
  }

  <div class="esn-feedback-form__footer">
    <esn-button class="esn-feedback-form__action" variant="secondary" [disabled]="!dirty()" (clicked)="clear()">
      {{ clearLabel() }}
    </esn-button>
    <esn-button class="esn-feedback-form__action" variant="primary" type="submit" [disabled]="!ready()">
      {{ submitLabel() }}
    </esn-button>
  </div>
</form>
